import { Routes, Route } from "react-router-dom"; 
import Header from "../src/components/header.jsx"; 
import Chatbot from "./components/Chatbot";
import HomePage from "./pages/homepage.js";
import Service from "./pages/service.js";
import Aboutus from "./pages/aboutus.js";
import CoursePage from "./pages/coursepage.js";
import CountryPages from "./pages/CountryPages.js";
import CareerCounsellingPage from "./pages/CareerCounsellingPage.js";
import BlogPage from "./pages/BlogPage.js";
import Footer from "./components/footer.jsx";
import ComparisonChart from "./components/ComparisonChart.jsx";
import LegalPolicies from "./components/LegalPolicies.jsx";
import ServiceDetail from "./components/ServiceDetail.jsx";
import OurPartners from "./components/OurPartners.jsx";
import InteractivePanelsPage from "./components/InteractivePanelsPage.jsx";
import ITSupplies from "./components/ITSupplies.jsx";
import Registration from "./pages/registration.js";
import ScrollToTop from "./components/ScrollToTop.jsx";
import AdminDashboard from "./components/AdminDashboard.jsx";
import StudentDashboard from "./components/StudentDashboard.jsx";
import PrincipalDashboard from "./components/PrincipalDashboard.jsx";
import TeacherDashboard from "./components/TeacherDashboard.jsx";
import CoachingPartnerDashboard from "./components/CoachingPartnerDashboard.jsx";
import CareerCounsellorDashboard from "./components/CareerCounsellorDashboard.jsx";

function App() {
  return (
    <>
      <ScrollToTop/>
      <Header /> 
      
      <main>
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/register" element={<Registration/>}/>
          <Route path="/service" element={<Service/>}/>
          <Route path="/about" element={<Aboutus/>}/>
          <Route path="/courses" element={<CoursePage/>}/>
          <Route path="/study-abroad/:countryName" element={<CountryPages />} />
          <Route path="/counselling-registration" element={<CareerCounsellingPage/>}/>
          <Route path="/blog" element={<BlogPage/>}/>
          <Route path="/comparison-chart" element={<ComparisonChart/>}/>
          <Route path="legal-policies" element={<LegalPolicies/>}/>
          <Route path="/services/:serviceName" element={<ServiceDetail/>}/>
          <Route path="/ourpartners" element={<OurPartners/>}/>
          <Route path="/interactivepanels" element={<InteractivePanelsPage/>}/>
          <Route path="/products" element={<ITSupplies/>}/>
          
          {/* ====================================================
              ADMIN SECTION: INDIVIDUAL INSPECTION ROUTES (FIXED)
             ==================================================== */}
          <Route path="/admin" element={<AdminDashboard/>}/>
          
          {/* Alag-alag roles ke liye distinct aur correct routes setup kiye hain */}
          <Route path="/admin/student/:id" element={<StudentDashboard viewMode="admin" />} />
          <Route path="/admin/principal/:id" element={<PrincipalDashboard />} />
          <Route path="/admin/teacher/:id" element={<TeacherDashboard />} />
          <Route path="/admin/coaching-partner/:id" element={<CoachingPartnerDashboard />} />
          
          {/* Abhi ke liye career counsellor par principal bhej rahe hain, jab aap logic btaoge tab iska alag component daal denge */}
          <Route path="/admin/career-counsellor/:id" element={<CareerCounsellorDashboard />} />
          
          {/* ====================================================
              LOGGED-IN USERS SELF DASHBOARD SECTION
             ==================================================== */}
          <Route path="/student/:id" element={<StudentDashboard viewMode="student" />} />
          <Route path="/principal-dashboard" element={<PrincipalDashboard />} />
          <Route path="/teacher-dashboard" element={<TeacherDashboard/>}/>
          <Route path="/coachingpartner" element={<CoachingPartnerDashboard/>}/>
          <Route path="/careercounsellor" element={<CareerCounsellorDashboard/>}/>
          
        </Routes>
      </main>

      <Chatbot />
      <Footer/>
    </>
  );
}

export default App;